import axios from "axios";



const instance = axios.create({
	// baseURL: "http://localhost:8080/",
	baseURL: window.location.origin + '/' + process.env.PUBLIC_URL,
	"Access-Control-Allow-Origin": "*",
	// "Content-Type": "application/json"
});

export default instance